// D-1013 (ひろ 2026-10-08 の選択): ランチャーのモジュールタイルとクレサポの入口(hub-nav)の線のアイコン。
//   クレサポ=route / タナサポ=package-check / マネサポ=layout-dashboard /
//   巡回MAP=map / 予定表=calendar-days / ランキング=trophy / タグSCAN=scan-line /
//   (未実装タイル)売上集計=chart-column / マスタ参照=book-open。
// 出典: Lucide (https://lucide.dev) — lucide-static v0.460.0 の SVG からそのまま。ISC License (Copyright (c) Lucide Contributors)。
//   ★lucide-react は入れない。NavSvg(24 / stroke 2 / round / currentColor)で包む。色は親の文字色を継ぐ。
//   ★roles.js のタイル定義は名前(icon: 'route' など)だけを持ち、描くときに HubIcon で引く。
import React from 'react'
import { NavSvg } from './NavIcons'

/** ランチャーのタイルのアイコンの一辺(px)。 */
export const HUB_TILE_ICON_PX = 30

/** クレサポ入口(hub-nav)のボタンのアイコンの一辺(px)。44px の箱に名前と縦に積む。 */
export const HUB_NAV_ICON_PX = 18

function make(name, children) {
  function Icon({ size = HUB_TILE_ICON_PX, className }) {
    return <NavSvg name={name} size={size} className={className}>{children}</NavSvg>
  }
  Icon.displayName = `HubIcon(${name})`
  return Icon
}

/** クレサポ — lucide: route */
export const RouteIcon = make('route', <>
  <circle cx="6" cy="19" r="3" />
  <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" />
  <circle cx="18" cy="5" r="3" />
</>)

/** タナサポ — lucide: package-check */
export const PackageCheckIcon = make('package-check', <>
  <path d="m16 16 2 2 4-4" />
  <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14" />
  <path d="m7.5 4.27 9 5.15" />
  <polyline points="3.29 7 12 12 20.71 7" />
  <line x1="12" x2="12" y1="22" y2="12" />
</>)

/** マネサポ — lucide: layout-dashboard */
export const LayoutDashboardIcon = make('layout-dashboard', <>
  <rect width="7" height="9" x="3" y="3" rx="1" />
  <rect width="7" height="5" x="14" y="3" rx="1" />
  <rect width="7" height="9" x="14" y="12" rx="1" />
  <rect width="7" height="5" x="3" y="16" rx="1" />
</>)

/** 巡回MAP — lucide: map */
export const MapIcon = make('map', <>
  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
  <path d="M15 5.764v15" />
  <path d="M9 3.236v15" />
</>)

/** 予定表 — lucide: calendar-days */
export const CalendarDaysIcon = make('calendar-days', <>
  <path d="M8 2v4" />
  <path d="M16 2v4" />
  <rect width="18" height="18" x="3" y="4" rx="2" />
  <path d="M3 10h18" />
  <path d="M8 14h.01" />
  <path d="M12 14h.01" />
  <path d="M16 14h.01" />
  <path d="M8 18h.01" />
  <path d="M12 18h.01" />
  <path d="M16 18h.01" />
</>)

/** ランキング — lucide: trophy */
export const TrophyIcon = make('trophy', <>
  <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
  <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
  <path d="M4 22h16" />
  <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
  <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
  <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
</>)

/** タグSCAN — lucide: scan-line */
export const ScanLineIcon = make('scan-line', <>
  <path d="M3 7V5a2 2 0 0 1 2-2h2" />
  <path d="M17 3h2a2 2 0 0 1 2 2v2" />
  <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
  <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
  <path d="M7 12h10" />
</>)

/** 売上集計(未実装タイル) — lucide: chart-column */
export const ChartColumnIcon = make('chart-column', <>
  <path d="M3 3v16a2 2 0 0 0 2 2h16" />
  <path d="M18 17V9" />
  <path d="M13 17V5" />
  <path d="M8 17v-3" />
</>)

/** マスタ参照(未実装タイル) — lucide: book-open */
export const BookOpenIcon = make('book-open', <>
  <path d="M12 7v14" />
  <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
</>)

/** 名前 → アイコン。roles.js のタイルの icon はここのキー。 */
export const HUB_ICONS = {
  'route': RouteIcon,
  'package-check': PackageCheckIcon,
  'layout-dashboard': LayoutDashboardIcon,
  'map': MapIcon,
  'calendar-days': CalendarDaysIcon,
  'trophy': TrophyIcon,
  'scan-line': ScanLineIcon,
  'chart-column': ChartColumnIcon,
  'book-open': BookOpenIcon,
}

/** 名前で引いて描く。知らない名前なら何も描かない。 */
export function HubIcon({ name, size, className }) {
  const Icon = HUB_ICONS[name]
  return Icon ? <Icon size={size} className={className} /> : null
}
